module.exports = __webpack_public_path__ + "img/20180815_150119_049.463fc3d9.jpg";